import {
  Datagrid,
  DateField,
  ReferenceManyField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  useRecordContext,
  useTranslate,
} from 'react-admin';

// Custom status field component to map status values to labels
const NotificationStatusField = () => {
  const record = useRecordContext();
  if (!record || record.status === undefined) return null;

  const statusMap: Record<number, { label: string; color: string }> = {
    0: { label: 'Pending', color: '#FFC107' }, // Yellow for pending
    1: { label: 'Processing', color: '#2196F3' }, // Blue for processing
    2: { label: 'Sent', color: '#4CAF50' }, // Green for sent
    3: { label: 'Failed', color: '#F44336' }, // Red for failed
  };

  const status = statusMap[record.status] || { label: `Unknown (${record.status})`, color: '#9E9E9E' };

  return (
    <div
      style={{
        backgroundColor: status.color,
        color: 'white',
        borderRadius: '16px',
        padding: '3px 8px',
        fontSize: '0.8125rem',
        display: 'inline-block',
        fontWeight: 500,
      }}
    >
      {status.label}
    </div>
  );
};

const NotificationShow = () => {
  const translate = useTranslate();

  return (
    <Show actions={false}>
      <TabbedShowLayout>
        <Tab label={translate('resources.common.main_information')}>
          <TextField source="id" />
          <TextField source="title" />
          <TextField source="text" multiline />
          <div style={{ display: 'flex', gap: '1rem', margin: '1rem 0' }}>
            <div>
              <strong>{translate('resources.notifications.fields.status')}: </strong>
              <NotificationStatusField />
            </div>
            <div>
              <strong>{translate('resources.notifications.fields.scheduled_at')}: </strong>
              <DateField source="scheduled_at" showTime />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '1rem', margin: '1rem 0' }}>
            <div>
              <strong>{translate('resources.notifications.fields.created_at')}: </strong>
              <DateField source="created_at" showTime />
            </div>
            <div>
              <strong>{translate('resources.notifications.fields.updated_at')}: </strong>
              <DateField source="updated_at" showTime />
            </div>
          </div>
        </Tab>

        <Tab label={translate('resources.notification_details.name')}>
          <ReferenceManyField target="notification_id" reference="notification_details">
            <Datagrid bulkActionButtons={false}>
              <TextField source="id" />
              <TextField source="tokens" sortable={false} />
              <NotificationStatusField />
              <DateField source="created_at" showTime />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default NotificationShow;
